import styled from 'styled-components'

interface SwitchButtonProps {
    active: boolean
    toggle: () => void
    customClass?: string
    text?: string
}

export const SwitchButton = ({
    active,
    toggle,
    customClass,
    text
}: SwitchButtonProps) => {
    return (
        <Button
            $active={active}
            $withText={!!text}
            className={`${text ? 'switchbutton__withText' : ''} ${
                customClass ?? ''
            }`}
            onClick={(e: React.MouseEvent<HTMLElement>) => {
                e.stopPropagation()
                toggle()
            }}
        >
            <Circle $active={active} />
            {text ? <Text $active={active}>{text}</Text> : ''}
        </Button>
    )
}

interface ButtonProps {
    $active: boolean
    $withText: boolean
}

const Button = styled.button<ButtonProps>`
    width: ${({ $withText }) => ($withText ? '12rem' : '5.2rem')};
    height: 2.6rem;
    display: flex;
    align-items: center;
    position: relative;
    padding: 0.4rem;
    border-radius: 2rem;
    border: 0;
    background: ${({ $active }) =>
        $active
            ? 'linear-gradient(92.95deg, #53aff7 -12.15%, #2894ff 111.4%)'
            : 'hsla(219, 11%, 70%, 0.5)'};
    font-family: Montserrat;
    font-weight: 800;
    letter-spacing: 0.02em;
    ${({ $withText }) =>
        $withText &&
        `
            font-size: 1.2rem;
            line-height: 1.5rem;
        `}
`

interface CircleProps {
    $active: boolean
}

const Circle = styled.div<CircleProps>`
    height: 2rem;
    width: 2rem;
    background: #fff;
    border-radius: 50%;
    ${({ $active }) => ($active ? 'margin-left:auto' : 'margin-left:0')};
`

interface TextProps {
    $active: boolean
}

const Text = styled.span<TextProps>`
    position: absolute;
    line-height: 1.5rem;
    font-size: 1.2rem;
    font-family: Montserrat;
    font-weight: 800;
    letter-spacing: 0.02em;
    color: ${({ $active }) => ($active ? '#fff' : '#757576')};
    transform: ${({ $active }) =>
        $active ? 'translateX(10%)' : 'translateX(80%)'};
    margin-left: 0.5rem;
`
